module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-24-e9860ff62971f4dca6eec8ccadad35ad.jpg";